module.exports = __webpack_public_path__ + "img/layout-8_2.ac02b4e4.png";